package tta.destinigo.talktoastro.feature_call_consultation.persentation.call_bottom_sheet_info

import tta.destinigo.talktoastro.feature_call_consultation.data.response.Data

sealed class CallPlaceInfoState {
    data class Error(val msg: String) : CallPlaceInfoState()
    data class Loading(val isLoading: Boolean) : CallPlaceInfoState()
    data class PlaceCallSuccess(val data: Data) : CallPlaceInfoState()
}